import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosInstance, AxiosResponse} from 'axios';
//enum
import {ACTION_TYPE} from '../actions-types';
//types
import {
	IOrganizationAuctionCategory,
	IOrganizationAuctionListRequest,
	IOrganizationAuctionListResponse,
	IOrganizationAuctionResponse,
	IOrganizationAuctionWonListResponse,
} from '../../utils/types';
//services
import {OrganizationAuctionService} from '@/utils/services';
//helpers
import {getErrorResponse} from '@/utils/helpers';

export const getAuctionList = createAsyncThunk(
	ACTION_TYPE.AUCTION_LIST,
	async (reqBody: IOrganizationAuctionListRequest, {rejectWithValue}) => {
		try {
			const auctionResponse: AxiosResponse<IOrganizationAuctionListResponse> =
				await OrganizationAuctionService.getAuctionList(reqBody);

			return auctionResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getAuctionCategories = createAsyncThunk(
	ACTION_TYPE.AUCTION_CATEGORIES,
	async (apiInstance: AxiosInstance, {rejectWithValue}) => {
		try {
			const auctionResponse: AxiosResponse<IOrganizationAuctionCategory[]> =
				await OrganizationAuctionService.getAuctionCategories(apiInstance);

			return auctionResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getAuction = createAsyncThunk(
	ACTION_TYPE.AUCTION,
	async ({id, apiInstance}: {id: number; apiInstance: AxiosInstance}, {rejectWithValue}) => {
		try {
			const auctionResponse: AxiosResponse<IOrganizationAuctionResponse> = await OrganizationAuctionService.getAuction(
				id,
				apiInstance
			);

			return auctionResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getAuctionWonList = createAsyncThunk(
	ACTION_TYPE.AUCTION_WON_LIST,
	async ({id, reqBody}: {id: number; reqBody: IOrganizationAuctionListRequest}, {rejectWithValue}) => {
		try {
			const auctionResponse: AxiosResponse<IOrganizationAuctionWonListResponse> =
				await OrganizationAuctionService.getAuctionWonList(id, reqBody);

			return auctionResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);
